<template>
  <div>
    <btn-back
      v-if="isMobile && isOpenForm"
      @click="closeTask()"
      :label="$t('msg.toTasksOfProject')"
    ></btn-back>
    <btns-nav
      v-if="btns.length > 0"
      :items="btns"
      class="pb-4"
    ></btns-nav>
    <card
      :label-top-left="project.name"
      :label-bottom-left="$t('msg.tasksOfProject')"
      :show-header="!isMobile || !isOpenForm"
    >
      <template v-slot:bottom>
        <filters
          v-if="!isMobile"
          v-model="filters"
          :bool-singles="['is_archive']"
          name="tasks"
          @clear="clearFilters"
        >
          <v-select
            v-model="filters.is_done"
            :label="$t('msg.isDone')"
            class="card__action"
            :items="$store.state.dict.statuses"
            item-value="value"
            item-text="text"
            clearable
            outlined
            dense
            hide-details
            @change="loadModels(openFirstTask)"
          ></v-select>
          <v-combobox
            v-model="filters.tags"
            :label="$t('msg.markers')"
            chips
            deletable-chips
            small-chips
            clearable
            multiple
            class="card__action"
            outlined
            dense
            hide-details
            hide-selected
            @change="loadModels(openFirstTask)"
          ></v-combobox>
          <v-switch
            v-model="filters.is_archive"
            :label="$t('msg.inArchive')"
            dense
            hide-details
            @change="loadModels(openFirstTask)"
          ></v-switch>
        </filters>
      </template>
      <template
        slot="header"
      >
        <v-btn
          small
          color="primary"
          fab
          @click="addTask()"
          elevation="0"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <filters
        v-if="isMobile && !isOpenForm"
        v-model="filters"
        :bool-singles="['is_archive']"
        name="tasks"
        class="mb-3"
      >
        <v-select
          v-model="filters.is_done"
          :label="$t('msg.isDone')"
          class="card__action"
          :items="$store.state.dict.statuses"
          item-value="value"
          item-text="text"
          clearable
          outlined
          dense
          hide-details
        ></v-select>
        <v-combobox
          v-model="filters.tags"
          :label="$t('msg.markers')"
          chips
          deletable-chips
          small-chips
          clearable
          multiple
          class="card__action"
          outlined
          dense
          hide-details
          hide-selected
        ></v-combobox>
        <v-switch
          v-model="filters.is_archive"
          :label="$t('msg.isArchive')"
          dense
          hide-details
        ></v-switch>
      </filters>
      <div class="card__multi" :class="{'card__multi_mobile': isMobile}">
        <div v-show="!isMobile || !isOpenForm" class="card__list">
          <v-progress-linear
            v-if="loading"
            indeterminate
          ></v-progress-linear>
          <div
            v-if="!loading && models.length === 0"
            class="card__not-tasks"
          >
            {{ $t('msg.thereAreNoTasksInTheProjectYet') }}
            <v-btn
              small
              color="primary"
              @click="addTask()"
              class="ml-3"
              elevation="0"
            >{{ $t('msg.add') }}
            </v-btn>
          </div>
          <draggable
            v-if="!loading && models.length > 0"
            v-model="models"
            class="task__tasks"
            :class="{'task__tasks_mobile': $vuetify.breakpoint.xsOnly}"
            @change="changeSequence($event)"
            @start="startSequence()"
            handle=".task__drag"
          >
            <div
              v-for="(task, key) in models"
              :key="key"
            >
              <div
                class="task__task"
                :class="{
                  'task__task_active': task.id === activeTask.id
                }"
              >
                <div
                  class="task__arrow"
                  :class="{'task__arrow_is': task.sub_tasks.length > 0}"
                  @click="clickArrow(task.id)"
                >
                  <v-icon
                    v-if="task.sub_tasks.length > 0"
                  >{{ openSubTasks.indexOf(task.id) >= 0 ? 'mdi-menu-down' : 'mdi-menu-right' }}
                  </v-icon>
                </div>
                <div class="task__mark">
                  <check-mark
                    v-model="task.is_done"
                    :id="projectId"
                    :sub-id="task.id"
                    @input="deleteTask(task.id, $event, models)"
                    action-change-false="changeTaskStatusNew"
                    action-change-true="changeTaskStatusDone"
                  ></check-mark>
                </div>
                <div
                  class="task__name"
                  :class="{'task__name_is-archive': task.is_archive}"
                  @click="openTask(task, true)"
                >{{ task.name }} <to-date :value="task.day_done"></to-date></div>
                <div class="task__tags">
                  <tag
                    v-for="(tag, key) in task.tag"
                    :key="key"
                    style="margin: 0 2px;"
                    :label="tag"
                  ></tag>
                </div>
                <v-icon
                  v-if="!$vuetify.breakpoint.xsOnly"
                  class="task__add-subtask"
                  :title="$t('msg.addSubtask')"
                  @click="addSubTask(task.id)"
                >mdi-plus
                </v-icon>
                <div v-if="!$vuetify.breakpoint.xsOnly" class="task__drag">
                  <v-icon
                    class="drag"
                  >mdi mdi-drag
                  </v-icon>
                </div>
              </div>
              <div
                v-if="openSubTasks.indexOf(task.id) >= 0"
              >
                <div
                  v-for="(subTask, key) in task.sub_tasks"
                  :key="'sub-'+key"
                  class="task__task"
                  :class="{
                                        'task__task_active': subTask.id === activeTask.id
                                    }"
                >
                  <div class="task__arrow task__arrow_sub-task"></div>
                  <div class="task__mark">
                    <check-mark
                      v-model="subTask.is_done"
                      :id="projectId"
                      :sub-id="subTask.id"
                      @input="deleteTask(subTask.id, $event, task.sub_tasks)"
                      action-change-false="changeTaskStatusNew"
                      action-change-true="changeTaskStatusDone"
                    ></check-mark>
                  </div>
                  <div
                    class="task__name"
                    :class="{'task__name_is-archive': subTask.is_archive}"
                    @click="openTask(subTask, false)"
                  >{{ subTask.name }} <to-date :value="subTask.day_done"></to-date></div>
                  <div class="task__tags">
                    <tag
                      v-for="(tag, key) in subTask.tag"
                      :key="key"
                      style="margin: 0 2px;"
                      :label="tag"
                    ></tag>
                  </div>
                  <div class="task__drag"></div>
                </div>
              </div>
            </div>
          </draggable>
        </div>
        <div v-show="!isMobile || isOpenForm" class="card__detail">
          <task-form
            v-if="isOpenForm"
            ref="taskForm"
            :project-id="parseInt(projectId)"
            :model="activeTask"
            :parent-task="activeTaskIsParent"
            @open-sub-task="openTask($event, false)"
            @add-sub-task="addSubTask($event)"
            @change-is-archive="changeIsArchive($event)"
            @change-task-id="changeTaskId($event)"
            :tasks="models"
          ></task-form>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import Actions from '../../../components/ui/Actions';
import CheckMark from '../../../components/ui/CheckMark';
import Draggable from 'vuedraggable';
import TaskForm from '../../../components/block/Plan/TaskForm';
import Filters from '../../../components/ui/Filters';
import Tag from "../../../components/ui/Tag";
import BtnBack from "../../../components/ui/BtnBack"
import BtnsNav from "../../../components/ui/BtnsNav";
import ToDate from "@/components/ui/ToDate";

export default {
  components: {Actions, CheckMark, Draggable, TaskForm, Filters, Tag, BtnBack, BtnsNav, ToDate},
  data() {
    return {
      loading: false,
      models: [],
      sequenceModels: [],
      filters: {
        is_done: false,
        tags: [],
        is_archive: false
      },
      projectId: null,
      project: {},
      openSubTasks: [],
      activeTask: {
        sub_tasks: []
      },
      activeTaskIsParent: true,
      isOpenForm: false,
      delay: (function () {
        let timer = 0;
        return function (callback, ms) {
          clearTimeout(timer);
          timer = setTimeout(callback, ms);
        };
      })()
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    btns() {
      let ret = [];

      if (!this.isMobile || !this.isOpenForm) {
        ret.push({
          label: this.$t('msg.reportByTasks'),
          to: {name: 'tasks_report', params: {id: this.projectId}}
        });
      }

      return ret;
    }
  },
  methods: {
    clearFilters() {

      this.filters.is_done = null;
      this.filters.tags = [];
      this.filters.is_archive = false;

      this._loadModels();
    },
    loadModels(callback) {
      this.delay(() => this._loadModels(callback), 100);
    },
    _loadModels(callback) {
      this.loading = true;
      this.$store.dispatch('loadTasks', {
        id: this.projectId,
        params: this.filters
      })
        .then(res => {

          res.forEach((item, key) => {
            if (item.day_done !== null) {
              res[key].day_done = item.day_done.slice(0, 10);
            }
            item.sub_tasks.forEach((item, key) => {
              if (item.day_done !== null) {
                item.day_done = item.day_done.slice(0, 10);
              }
            })
          });

          this.models = res;
          this.sequenceModels = res;
          if (typeof callback === 'function' && !this.isMobile) {
            callback();
          }
        })
        .finally(() => this.loading = false);
    },
    loadProject() {
      this.$store.dispatch('loadProject', {id: this.projectId})
        .then(res => {
          this.project = res;
          this.$store.commit('setBreadcrumbs', [{id: 2, name: this.project.name}]);
        });
    },
    deleteTask(taskId, v, items) {
      // if (this.filters.is_done === false) {
      //   if (v === true) {
      //     const index = items.findIndex(v => v.id === taskId);
      //     items.splice(index, 1);
      //   }
      // }
      // if (this.filters.is_done === true) {
      //   if (v === false) {
      //     const index = items.findIndex(v => v.id === taskId);
      //     items.splice(index, 1);
      //   }
      // }
    },
    changeSequence(event) {

      let res = this.recountSequenceModels(this.models, this.sequenceModels, event);

      this.sequenceModels = res.models;

      this.$store.dispatch('changeTaskSequence', {
        id: this.projectId,
        subId: res.id,
        data: {
          from_seq: res.from,
          to_seq: res.to,
        },
      });
    },
    startSequence() {
      this.sequenceModels = this.models;
    },
    clickArrow(id) {
      const i = this.openSubTasks.indexOf(id);
      if (i >= 0) {
        this.openSubTasks.splice(i, 1);
      } else {
        this.openSubTasks.push(id);
      }
    },
    openTask(task, isParent) {
      this.activeTask = task;
      this.activeTaskIsParent = isParent;
      this.isOpenForm = true;
      if (this.activeTask.id === null) {
        this.$nextTick(() => this.$refs.taskForm.focusName());
      }
    },
    openFirstTask() {
      if (this.models.length > 0) {

        if (!!this.$route.query.task_id) {
          this.models.forEach((item, i) => {
            let taskId = parseInt(this.$route.query.task_id);
            if (item.id === taskId) {
              this.openTask(item, true);
            } else {
              if (!item.sub_tasks) return;
              let key = item.sub_tasks.map(v => v.id).indexOf(taskId);
              if (key > -1) {
                this.openTask(item.sub_tasks[key], false);
              }
            }
          });
        } else {
          this.openTask(this.models[0], true);
        }
      }
    },
    addTask() {
      let newTask = {
        id: null,
        name: null,
        desc: null,
        tag: [],
        note_id: null,
        sub_tasks: [],
        is_archive: false,
        duration: null,
        day_done: null,
      };
      this.models.push(newTask);
      this.openTask(newTask, true);
      this.isOpenForm = true;
    },
    addSubTask(modelId) {
      let key = this.models.map(model => model.id).indexOf(modelId);

      let newTask = {
        id: null,
        task_id: modelId,
        name: null,
        desc: null,
        tag: [],
        note_id: null,
        sub_tasks: [],
        is_done: false,
        is_archive: false,
        duration: null,
        day_done: null,
      };

      this.models[key].sub_tasks.push(newTask);
      this.openTask(newTask, false);

      this.openSubTasks.push(modelId)
    },
    changeIsArchive({id, taskId}) {
      // if (taskId === null) {
      //   let key = this.models.map(item => item.id).indexOf(id);
      //   this.models.splice(key, 1);
      // } else {
      //   let key = this.models.map(item => item.id).indexOf(taskId);
      //   let subKey = this.models[key].sub_tasks.map(item => item.id).indexOf(id);
      //   this.models[key].sub_tasks.splice(subKey, 1);
      // }
      // this.$refs.taskForm.submit()
      //   .then(() => this.openFirstTask());
    },
    changeTaskId(task) {

      let callback = () => {
        this.models.forEach(model => {
          if (model.id === task.id) {
            this.openTask(model, true);
          } else {
            model.sub_tasks.forEach(subTask => {
              if (subTask.id === task.id) {
                this.openTask(subTask, false);
              }
            });
          }
        });
      };

      this._loadModels(callback);
    },
    closeTask() {
      this.isOpenForm = false;
      this.activeTask.id = null;
    }
  },
  created() {
    this.projectId = this.$route.params.id;
    this.loadProject();
    this.loadModels(this.openFirstTask);
  }
}
</script>

<style lang="scss">
@import 'src/assets/scss/vars';

.task__tasks {
  border-bottom: 1px solid #eee;

  &.task__tasks_mobile {
    .task__name {
      padding: 10px 10px;
    }

    .task__arrow {
      width: 40px;
      padding: 0;

      &.task__arrow_sub-task {
        width: 70px;
      }

      .v-icon {
        font-size: 36px
      }
    }
  }
}

.task__arrow {
  width: 30px;
  padding: 2px 5px;

  &.task__arrow_is {
    cursor: pointer;
  }

  &.task__arrow_sub-task {
    width: 60px;
  }
}

.task__task {
  display: flex;
  align-items: center;
  border-top: 1px solid #eee;
  transition: 200ms;

  &:hover {
    background-color: #eee;
  }

  &.task__task_active {
    background-color: $colorPrimaryLight;
  }
}

.task__name {
  min-height: 31px;
  flex: 1;
  color: #000;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 6px 10px 6px 10px;
  user-select: none;

  &.task__name_is-archive {
    color: #00000040;
  }
}

.task__tags {
  .v-chip {
    height: 18px;
    padding: 0 8px;
    font-size: 11px;
    font-weight: bold;
  }
}

.task__drag {
  width: 24px;
}

.card__not-tasks {
  text-align: center;
}

.task__add-subtask {
  font-size: 22px !important;
  cursor: pointer;
  border-radius: 50%;

  &:hover {
    background-color: #d6d6d6;
  }
}
</style>